                       import useFavicon from "../../../hooks/useFavicon";

export default function Favicon({ siteId }) {
	 useFavicon({ siteId }); 
	return null;
}
